import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "33",
  fill: "none",
  viewBox: "0 0 48 33"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#35467D\" d=\"M0 22.088v6.348c0 2.633 2.09 4.49 4.645 4.49h38.71c2.555 0 4.645-1.858 4.645-4.49v-6.348z\"></path><path fill=\"#B93E51\" d=\"M43.355.41H4.645C2.09.41 0 2.268 0 4.9v6.349h48V4.9C48 2.268 45.91.41 43.355.41\"></path><path fill=\"#E9EFF4\" d=\"M48 11.248H0v10.839h48z\"></path><path fill=\"#3B4E85\" d=\"M43.2 32.927c2.555 0 4.8-1.858 4.8-4.49v-6.35H30.505z\"></path><path fill=\"#9F2638\" d=\"M43.354.41H4.644l12.853 10.84H48V4.9C48 2.268 45.91.41 43.354.41\"></path><path fill=\"#CFDCE5\" d=\"M30.58 22.087h17.419V11.248H17.418z\"></path><path fill=\"#AD293A\" d=\"M43.354.41H4.644L40.49 11.25H48V4.9C48 2.268 45.908.41 43.353.41\"></path><path fill=\"#BCCED8\" d=\"M47.998 13.416v-2.168h-7.896z\"></path><path fill=\"#3B4E85\" d=\"M48 28.359c0 2.787-2.09 4.567-4.645 4.567H4.645C2.09 32.926 0 30.913 0 28.281\"></path>", 9)
  ])))
}
export default { render: render }